import { useDeleteAny, useListAny, usePostAny, usePutAny } from ".";
import { CreateGroupRequest, UpdateUserRequest } from "../types/types";

export enum ACL {
  ADMIN,
  USER,
}

export type Group = {
  id: string;
  name: string;
  createdAt: Date;
  updatedAt: Date | null;
  users: User[];
}

export type User = {
  id: string;
  active: boolean;
  userName: string;
  acl: ACL;
  createdAt: Date;
  deletedAt: Date | null;
  lastLogin: {
    Valid: boolean;
    Time: Date | null;
  };
  updatedAt: Date | null;
  group: Group;
  groupId: string;
}

export function useListUsers() {
  return useListAny<User[]>("/admin/users");
}

export function useListGroups() {
  return useListAny<Group[]>("/admin/groups");
}

export function useUpdateUser() {
  return usePutAny<{}, UpdateUserRequest>();
}

export function useCreateGroup() {
  return usePostAny<{},CreateGroupRequest>("/admin/group"); 
}

export function useDeleteUser() {
  return useDeleteAny<{}>();
}